import { OrderPredictionsApi } from '@/api';
import { toCarts } from '@/modules/store/mappers/mapOrderPrediction';
import { Cart } from '@/modules/store/models/Cart';

interface AutoOrderService {
  predictOrders(): Promise<Cart[]>;
  isPredictionAvailable(): Promise<boolean>;
}

class AutoOrderServiceImpl implements AutoOrderService {
  private orderPredictionsApi: OrderPredictionsApi;

  constructor(orderPredictionsApi: OrderPredictionsApi) {
    this.orderPredictionsApi = orderPredictionsApi;
  }

  async predictOrders(): Promise<Cart[]> {
    const result = await this.orderPredictionsApi.generateOrderPrediction();

    return result ? toCarts(result) : [];
  }

  async isPredictionAvailable(): Promise<boolean> {
    const result = await this.orderPredictionsApi.getOrderPredictionStatus();
    return result?.available || false;
  }
}

export default AutoOrderServiceImpl;
